var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-back",attrs:{"variant":"link"},on:{"~click":function($event){return _vm.back($event)}}},[_c('icon-base',{attrs:{"width":"14","height":"25"}},[_c('icon-caret-right')],1),_vm._v(" Back")],1)}
var staticRenderFns = []

export { render, staticRenderFns }